import t from '@/hosted_fields/common/locale';
import LoggerInterface from '@/utils/logger/interface';
import '@/helpers/polyfills';
import {Metadata} from '@/plugins/logger/types';

export default abstract class Logger implements LoggerInterface {
  meta: Metadata; // TODO define type for meta
  ready: Promise<any>;

  constructor(meta?: Metadata) {
    if (meta) this.setMetadata(meta);
    this.ready = this.initialize();
  }

  abstract initialize(): Promise<any>;

  setMetadata(meta: Metadata) {
    if (meta && typeof meta === 'object' && Object.keys(meta).length > 0) {
      this.meta = meta;
    }
  }

  abstract log(data: any);

  abstract logError(err: Error, extra?: any);

  static throw(err, extraData?) {
    // throw Logger.error(err, extraData);
  }

  static getMaskedError(): Error {
    // Create a masked error
    let maskedError = new Error();
    maskedError.name = 'unknown_error';
    maskedError.message = t('error.unknownError');

    return maskedError;
  }

  static throwMaskedError(err, extraData?) {
    // Logger.error(err, extraData);
    throw Logger.getMaskedError();
  }

  static sanitizeError(err): Error {
    if (err instanceof Error || (err && err.name)) {
      const error = new Error();
      error.name = err.name;
      error.message = err.displayMessage || err.message;
      error.stack = err.stack;
      return error;
    }
    return new Error(err);
  }
}
